import api from '../../../api';

import {
  DeleteRevokeInframailIpsRequest,
  GetInframailIpsRequest,
} from '../types';

export const getInframailIps = async (params: GetInframailIpsRequest) =>
  api.get(`/domain/host-orders`, { params });

export const getInframailIpsDomains = async (hostId: string) =>
  api.get(`domain/${hostId}/domains`);

export const deleteRevokeInframailIps = async ({
  id,
  action,
}: DeleteRevokeInframailIpsRequest) =>
  api.patch(`/domain/order/${id}?action=${action}`);
